import Service from "../../AuthService";

const deposit = {
    getDeposit(page) {
        return Service.get("/deposit?page="+page);
    },
    showDeposit(id,page) {
        return Service.get("/deposit/" + id +'?page='+page);
    },
    searchDetail(data) {
        return Service.get(`/deposit_details_search?id=${data.id}&date_start=${data.date_start}&date_end=${data.date_end}&page=${data.page}`);
    },
    updateDeposit(id, data) {
        return Service.put("/deposit/" + id, data);
    },
    createDeposit(data) {
        return Service.post("/deposit", data);
    },
    deleteDeposit(id) {
        return Service.delete("/deposit/" + id);
    },
    search(page,data){
        return Service.post('/deposit-search?page='+page,data);
    }

};
export default deposit;
